import { render, staticRenderFns } from "./selectProductModal.vue?vue&type=template&id=23c67b00&"
import script from "./selectProductModal.vue?vue&type=script&lang=ts&"
export * from "./selectProductModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports